import { render, staticRenderFns } from "./NCBRecovery.vue?vue&type=template&id=49d92c1e&scoped=true"
import script from "./NCBRecovery.vue?vue&type=script&lang=js"
export * from "./NCBRecovery.vue?vue&type=script&lang=js"
import style0 from "./NCBRecovery.vue?vue&type=style&index=0&id=49d92c1e&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "49d92c1e",
  null
  
)

export default component.exports